export const AppConfig = {
  WEB_APP_URL: process.env.WEB_APP_URL,
  DOMAIN: process.env.MAIN_DOMAIN,
  BACKEND_URL: process.env.BACKEND_URL
};
